import { Component, Host, h, Prop } from '@stencil/core';
import { localizeNumbers } from '../../../utils/utils';
import state from './../../../state/cta-price';

@Component({
  tag: 'afs-cta-price-total',
  styleUrl: 'afs-cta-price-total.sass',
  shadow: true,
})
export class AfsCtaPriceTotal {

    @Prop() color : string = "#000000";
    @Prop() fr : boolean = false;
    @Prop() langHeading : string = this.fr ? "Prix total" : "Total Price";

    render() {
        return (
        <Host style={{color: this.color}}>
            <h3>{this.langHeading}</h3>
            <h2>{localizeNumbers(state.totalPrice, true)}</h2>
        </Host>
        );
    }

}
